import {
  toIANATimeZone,
  fromLegacyTimeZone,
} from '@bingads-webui-universal/time-zone-converter';

export const getTimeZoneStr = serverContext =>
  toIANATimeZone(fromLegacyTimeZone(serverContext.CurrentAccount.TimeZone || 71));

const last7Days = (i18n, timeZoneStr) => {
  const today = new Date();
  const weekBack = new Date();
  weekBack.setDate(weekBack.getDate() - 7);
  const formatterOptions = {
    timeZone: timeZoneStr,
    raw: 'yyyy-MM-dd',
  };

  return {
    start: i18n.formatDate(weekBack, formatterOptions),
    end: i18n.formatDate(today, formatterOptions),
  };
};

export default function preferContextDefaultValueCreater(i18n, serverContext) {
  return {
    dashboardDateRange: last7Days(i18n, getTimeZoneStr(serverContext)),
  };
}
